export const data = {
  access_token: "access_token",
  pub_guest_token: "pub_guest_token",
  guest_info: "guest_info",
  plant_idx: "plant_idx",
  last_login_account: "last_login_username",
  locale: "locale",
  version: "version",
  selectColHeader: "selectColHeader",
  allhearder: "allhearder"
};
export const get = function (k) {
  if (localStorage.getItem(k)) return localStorage.getItem(k);
};
export const set = function (k, v) {
  return localStorage.setItem(k, v);
};
export const remove = function (k) {
  return localStorage.removeItem(k);
};
export const clear = function () {
  localStorage.clear();
};
